require('./cardDownloadPDFView.scss');

// @vendors
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @utilities
const AccessHelper = require('utilities/accessHelper');
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const { nonNumericFilter } = require('utilities/stringHelper');
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const { formatCardNumber } = require('utilities/cardsHelper');
const { PAGE_GENERIC, recordPath } = require('utilities/tagging');

// @actions
const cardDownloadPdfActions = require('actions/getCardDownloadPDF');

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @components
const CardDetailsSideBar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const CardDownloadPDFError = require('components/cards/cardDownloadPDF/cardDownloadPDFError/cardDownloadPDFError');
const CardDownloadPDFSuccess = require('components/cards/cardDownloadPDF/cardDownloadPDFSuccess/cardDownloadPDFSuccess');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKLink } = require('commonsComponents/OKLink');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');

// @constants
const {
    CARD_DOWNLOAD_PDF_ID,
    MULTIPLE_OPERATIONS,
    messages: { CODIGO_MESSAGE_1 }
} = require('constants/operationTypes');

const {
    CARD_ECARD,
    CARD_VIRTUAL_DEBIT,
    CARD_VIRTUAL_CREDIT
} = require('constants/index');

class CardDownloadPDFView extends React.Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    componentDidMount() {
        const { history, immCards, match: { params: { cardId } } } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        AccessHelper.allowAccess(cardConstants.CARD_DOWNLOAD_PDF, { immCard }, history);

        const tagging = immCard.get('tagging');
        recordPath('tarjeta/descargar-ecard-pdf', PAGE_GENERIC, '', '', tagging);
    }

    componentWillUnmount() {
        const { resetCardDownloadPdf } = this.props;
        resetCardDownloadPdf();
    }

    buildTwoColumnSection(immCard, content) {
        return (
            <div>
                {/* >> CONTENT DUPLICATED: REF-01 */}
                <div className="col-md-12 hidden-lg grid-view--fix-cell-separation-bottom">
                    <CardDetailsSideBar immCard={immCard} />
                </div>
                {/* CONTENT DUPLICATED: REF-01 << */}
                <div className="col-md-12 col-lg-8">
                    <OKSectionBox>
                        {content}
                    </OKSectionBox>
                </div>
                {/* >> REF-01 */}
                <div className="hidden-xs hidden-sm hidden-md col-lg-4">
                    <CardDetailsSideBar immCard={immCard} />
                </div>
                {/* REF-01 << */}
            </div>
        );
    }

    handleSubmit() {
        const { getCardDownloadPdf, match: { params: { cardId } } } = this.props;

        if (cardId) {
            getCardDownloadPdf(cardId);
        }
    }

    isReady() {
        return false;
    }

    render() {
        const { immCards, immCardDownloadPdf, match: { params: { cardId } } } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        let cardType, block, sectionContent;

        if (immCard.get('type') === CARD_ECARD) {
            cardType = CARD_ECARD
        } else if (immCard.get('isVirtualDebit')) {
            cardType = CARD_VIRTUAL_DEBIT
        } else if (immCard.get('isVirtualCredit')) {
            cardType = CARD_VIRTUAL_CREDIT
        }

        if (immCard) {
            const pageTitleKey = 'breadcrumb-cardDownloadPDF';
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.getIn(['alias', 'current']),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText(pageTitleKey),
                    url: ''
                }
            ];

            if (immCardDownloadPdf.get('success')) {
                sectionContent = (
                    <CardDownloadPDFSuccess
                        immCard={immCard}
                        cardType={cardType}
                    />
                );
            } else if (!!immCardDownloadPdf.get('error')) {
                sectionContent = (<CardDownloadPDFError immCard={immCard} />);
            } else {
                const operationParams = {
                    id: CODIGO_MESSAGE_1,
                    requestMulti: [
                        {
                            serviceCode: CARD_DOWNLOAD_PDF_ID,
                            pan: nonNumericFilter(immCard.get('number'))
                        },
                        {
                            serviceCode: CARD_DOWNLOAD_PDF_ID,
                            pan: nonNumericFilter(immCard.get('number'))
                        }
                    ]
                };
                const linkToCard = `/myprofile/cards/${cardId}/details`;
                const hiddenCardNumber = formatCardNumber(immCard.get('number'), 4, '*');

                sectionContent = this.buildTwoColumnSection(immCard, (
                    <article>
                        <PreLeaveModalComponent
                            confirmationMessage={formatText('wizard-redirectConfirmationMessage')}
                            confirmationTitle={formatText('wizard-redirectConfirmationTitle')}
                            acceptText={formatText('wizard-redirectConfirmationAcceptButton')}
                            cancelText={formatText('wizard-redirectConfirmationCancelButton')}
                            isReady={this.isReady}
                        />
                        <header className="card-download-pdf__header">
                            <FormattedText value="cardDownloadPDF-cardDownloadPDF_title" />
                        </header>
                        <section className="card-download-pdf__informative-text">
                            <FormattedText
                                value="cardDownloadPDF-cardDownloadPDF_informativeText"
                                injectedStrings={[cardType]}
                            />
                            <span className="card-download-pdf__value">
                                {hiddenCardNumber}
                            </span>
                        </section>
                        <SignaturePattern
                            operationType={MULTIPLE_OPERATIONS}
                            operationParams={operationParams}
                        />
                        <footer className="card-download-pdf__footer">
                            <div className="card-download-pdf__cancel-button">
                                <OKLink
                                    modifier="inherit-styles"
                                    to={linkToCard}
                                >
                                    <FormattedText value="cardRequests-cancel" />
                                </OKLink>
                            </div>
                            <SignaturePatternButton onClick={this.handleSubmit}>
                                <FormattedText value="cardDownloadPDF-cardDownloadPDF_request" />
                            </SignaturePatternButton>
                        </footer>
                    </article>
                ));
            }

            block = (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={formatText(`cards-${immCard.get('type')}`)}
                                    subtitleRight={immCard.getIn(['alias', 'current'])}
                                    finalTitle={getFinalTitle(pageTitleKey)}
                                >
                                    <CardHeaderDetails immCard={immCard} />
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                {sectionContent}
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            block = <LoadingSection />;
        }

        return block;
    }
}

CardDownloadPDFView.propTypes = {
    getCardDownloadPdf: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardDownloadPdf: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    resetCardDownloadPdf: PropTypes.func.isRequired
};

module.exports.constructor = CardDownloadPDFView;
module.exports.CardDownloadPDFView = connect(
    state => ({
        immCards: state.cards,
        immCardDownloadPdf: state.cardDownloadPdf
    }),
    {
        getCardDownloadPdf: cardDownloadPdfActions.getCardDownloadPdf,
        resetCardDownloadPdf: cardDownloadPdfActions.resetCardDownloadPdf
    }
)(withRouter(CardDownloadPDFView));
